// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ArrowBackward, { ArrowBackwardOffset } from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import { menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { menuPanelProps } from "@store/Themes/common/props/menu";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

/* Store Custom Code - Start */
import ChevronLeft from "@store/Library/Components/Toolkit/Icons/ChevronLeft";
import { IconWrapper } from "@insite/mobius/Icon";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
/* Store Custom Code - End */

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        cssOverrides: {
            children: menuPanelProps.wrapperCss,
            menu: menuPanelProps.menuCss,
        },
        closeButtonPanelRowProps: {
            css: menuPanelProps.headerCss,
        },
        closeButtonProps: menuPanelProps.closeButton,
        closeIconProps: menuPanelProps.closeButtonIcon,
        parentPanelRowProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "inherit",
                    hoverColor: "inherit",
                    hoverUnderline: false,
                })}
                /* Store Custom Code - Start */
                display: flex;
                align-items: center;
                width: 100%;
                text-align: left;
                font-weight: ${x => x.theme.design.typography.weight.bold};

                > ${IconWrapper} {
                    svg {
                        width: ${pxToRem(40)};
                    }
                }
                /* Store Custom Code - End */
            `,
        },
        parentLinkProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    // Store Custom Code
                    color: "secondary.dark",
                })}

                width: auto;
                padding: 0;
                white-space: nowrap;
                /* Store Custom Code */
                font-weight: ${x => x.theme.design.typography.weight.base};
                text-decoration: underline;
            `,
        },
        /* Store Custom Code - Start */
        backIconProps: { src: ArrowBackward, width: 40 },
        parentTypographyProps: {
            ellipsis: true,
            weight: "bold",
        },
        /* Store Custom Code - End */
        bodyColor: "transparent",
        panelRowProps: {
            /* Store Custom Code - Start */
            css: css`
                ${menuPanelRowStyles({ iconPosition: "right" })}

                ${({ theme }) => css`
                    font-size: ${theme.design.typography.size.base};
                `}
            `,
            /* Store Custom Code - End */
            isCurrentCss: css`
                background-color: transparent;
                /* Store Custom Code */
                color: ${getColor("text.main")};
                font-weight: ${x => x.theme.design.typography.weight.bold};
                span {
                    font-weight: ${x => x.theme.design.typography.weight.bold};
                }
            `,
            moreIconProps: { src: ChevronRight },
        },
        childTypographyProps: {
            size: "inherit",
            // Store Custom Code
            weight: "normal",
        },
    },
};

export default panelMenu;
